import React, { useState, useEffect } from 'react';
import { Typography, DatePicker, Card, Row, Col, Table, Button } from 'antd';
import AssignmentCard from '../../../components/cards/AssignmentCard';
import TableWithPagination from '../../../components/TableWithPagination';

const { Title } = Typography;

const assignments = [
    {
        title: 'Math Assignment',
        description: 'Solve algebraic equations and submit your solutions.',
        dueDate: '2025-01-10', // Past due date
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=1',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'Science Project',
        description: 'Prepare a project on renewable energy sources.',
        dueDate: '2025-01-15', // Past due date
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=2',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'History Essay',
        description: 'Write an essay on the causes of World War I.',
        dueDate: '2025-02-10',
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=3',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'Geography Assignment',
        description: 'Prepare a detailed map of your local area.',
        dueDate: '2025-01-05', // Past due date
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=4',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'English Literature Review',
        description: 'Read "To Kill a Mockingbird" and write a review.',
        dueDate: '2025-02-05',
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=5',
        status: 'Completed',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'Chemistry Lab Report',
        description: 'Complete the lab report based on the last experiment.',
        dueDate: '2025-01-12', // Past due date
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=6',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
    {
        title: 'Programming Assignment',
        description: 'Build a simple React application with routing.',
        dueDate: '2025-02-15',
        avatarSrc: 'https://api.dicebear.com/7.x/miniavs/svg?seed=7',
        status: 'Pending',
        pdfUrl: "https://morth.nic.in/sites/default/files/dd12-13_0.pdf"
    },
];



// Dummy API function
const fetchAssignmentHistory = (page, pageSize) => {
    const totalAssignments = 50; // Example total items
    const assignments = Array.from({ length: totalAssignments }, (_, index) => ({
        key: index + 1,
        title: `Assignment ${index + 1}`,
        description: `Description for assignment ${index + 1}`,
        dueDate: `2025-01-${String((index % 30) + 1).padStart(2, '0')}`,
        status: index % 2 === 0 ? 'Completed' : 'Pending',
    }));

    // Paginate results
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    return Promise.resolve({
        data: assignments.slice(start, end),
        total: totalAssignments,
    });
};

const Assignments = () => {
    const [date, setDate] = useState(null);
    const [historyData, setHistoryData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    const handleDateChange = (date, dateString) => {
        setDate(dateString);
        console.log('Selected date:', dateString);
    };

    const fetchHistory = async (page) => {
        const response = await fetchAssignmentHistory(page, pageSize);
        setHistoryData(response.data);
        setTotalItems(response.total);
    };

    useEffect(() => {
        fetchHistory(currentPage);
    }, [currentPage]);

    const columns = [
        { title: 'Title', dataIndex: 'title', key: 'title' },
        { title: 'Description', dataIndex: 'description', key: 'description' },
        { title: 'Due Date', dataIndex: 'dueDate', key: 'dueDate' },
        { title: 'Status', dataIndex: 'status', key: 'status' },
    ];

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    const handleNext = () => {
        if (currentPage < Math.ceil(totalItems / pageSize)) setCurrentPage((prev) => prev + 1);
    };

    return (
        <div className="assignments-container">
            <div className="flex justify-between items-center mb-6">
                <Title level={4}>Assignments</Title>
                <DatePicker
                    placeholder="Search by date"
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    style={{ width: 200 }}
                />
            </div>
            <Card title="Ongoing Assignments">
                <div className="flex gap-4 overflow-y-auto max-h-[20rem]">
                    {assignments
                        .filter((assignment) => assignment.status === 'Pending')
                        .map((assignment, index) => (
                            <div className=" w-60 md:w-96 flex-none">
                                <AssignmentCard
                                    key={index}
                                    title={assignment.title}
                                    description={assignment.description}
                                    dueDate={assignment.dueDate}
                                    avatarSrc={assignment.avatarSrc}
                                    status={assignment.status}
                                    pdfUrl={assignment.pdfUrl}
                                />
                            </div>

                        ))}
                </div>
            </Card>
            <Card title="Ongoing Assignments">
                <div className="flex gap-4 overflow-y-auto max-h-[20rem]">
                    {assignments
                        .filter((assignment) => assignment.status === 'Pending')
                        .map((assignment, index) => (
                            <div className=" w-60 md:w-96 flex-none">
                                <AssignmentCard
                                    key={index}
                                    title={assignment.title}
                                    description={assignment.description}
                                    dueDate={assignment.dueDate}
                                    avatarSrc={assignment.avatarSrc}
                                    status={assignment.status}
                                    pdfUrl={assignment.pdfUrl}
                                />
                            </div>

                        ))}
                </div>
            </Card>


            <div className="mt-8">
                <Title level={4}>Assignment History</Title>
                <TableWithPagination
                    url="ttps://dummyjson.com/users" // Replace with your API endpoint
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default Assignments;
